/**
 * This module is also used server side so should not import anything for the frontend.
 */
import type { SupabaseRegion } from '~/types/supabase';

const SOUTH_AMERICA_CITIES = ['Sao_Paulo', 'Argentina', 'Montevideo', 'Asuncion'];
const US_WEST_CITIES = ['Los_Angeles', 'Vancouver', 'Phoenix'];
const US_EAST_CITIES = ['New_York', 'Toronto', 'Montreal'];
const US_CENTRAL_CITIES = ['Chicago', 'Indiana', 'Detroit'];
const US_SOUTH_CITIES = ['Mexico_City', 'Denver', 'Chicago'];

const UK_IRELAND_CITIES = ['London', 'Dublin'];
const FRANCE_REGION_CITIES = ['Paris', 'Brussels', 'Zurich'];
const CENTRAL_EUROPE_CITIES = ['Berlin', 'Amsterdam', 'Vienna', 'Prague', 'Warsaw'];
const NORDIC_CITIES = ['Stockholm', 'Oslo', 'Copenhagen', 'Helsinki', 'Reykjavik'];
const SOUTH_EUROPE_CITIES = ['Madrid', 'Lisbon', 'Rome'];

const JAPAN_CITIES = ['Tokyo'];
const EAST_ASIA_CITIES = ['Seoul', 'Hong_Kong', 'Taipei'];
const SOUTHEAST_ASIA_CITIES = ['Singapore', 'Jakarta', 'Bangkok', 'Manila', 'Kuala_Lumpur', 'Ho_Chi_Minh'];
const INDIA_CITIES = ['Kolkata'];

export function timeZoneToSupabaseRegion(timezone: string | undefined): SupabaseRegion {
  if (!timezone) {
    return 'us-east-1';
  }

  const [continent, location] = timezone.split('/');

  switch (continent) {
    case 'America': {
      if (SOUTH_AMERICA_CITIES.includes(location)) {
        return 'sa-east-1';
      }

      if (US_WEST_CITIES.includes(location)) {
        return 'us-west-1';
      }

      if (US_EAST_CITIES.includes(location)) {
        return 'us-east-1';
      }

      if (US_CENTRAL_CITIES.includes(location)) {
        return 'us-east-2';
      }

      if (US_SOUTH_CITIES.includes(location)) {
        return 'ca-central-1';
      }

      return 'us-east-1';
    }

    case 'Europe': {
      if (UK_IRELAND_CITIES.includes(location)) {
        return 'eu-west-2';
      }

      if (FRANCE_REGION_CITIES.includes(location)) {
        return 'eu-west-3';
      }

      if (CENTRAL_EUROPE_CITIES.includes(location)) {
        return 'eu-central-1';
      }

      if (NORDIC_CITIES.includes(location)) {
        return 'eu-north-1';
      }

      if (SOUTH_EUROPE_CITIES.includes(location)) {
        return 'eu-west-1';
      }

      return 'eu-central-1';
    }

    case 'Asia': {
      if (JAPAN_CITIES.includes(location)) {
        return 'ap-northeast-1';
      }

      if (EAST_ASIA_CITIES.includes(location)) {
        return 'ap-northeast-2';
      }

      if (SOUTHEAST_ASIA_CITIES.includes(location)) {
        return 'ap-southeast-1';
      }

      if (INDIA_CITIES.includes(location)) {
        return 'ap-south-1';
      }

      return 'ap-southeast-2';
    }

    case 'Australia':
    case 'Pacific': {
      return 'ap-southeast-2';
    }

    default: {
      return 'us-east-1';
    }
  }
}
